import { AnimatedCheckIcon } from '@components/utils/icons/AnimatedCheckIcon';
import styled from '@emotion/styled';
import { Button } from '@lib/uikit';
import { FC, useState } from 'react';

import { useCopyToClipboard } from '../hooks/useCopyToClipboard';
import { CopyToClipboardButtonProps } from '../types';


const ANIMATION_DURATION_IN_MS = 1000;

const Absolute = styled.div`
    display: flex;
    position: absolute;
    right: ${({ theme }) => theme.spacing.sm};
`;

const Label = styled.span`
    color: black;
`;

export const CopyToClipboardButton: FC<CopyToClipboardButtonProps> = ({
    label,
    textToCopy,
}) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const { copy } = useCopyToClipboard();

    const animate = () => {
        setIsAnimating(true);
        setTimeout(() => setIsAnimating(false), ANIMATION_DURATION_IN_MS);
    };

    const handleClick = () => {
        animate();
        copy(textToCopy);
    };

    return (
        <Button
            isFullWidth
            leftIcon='copy'
            variant='outline'
            onClick={handleClick}
            colorScheme='white'
        >
            <Label>{label}</Label>
            <Absolute>
                <AnimatedCheckIcon isVisible={isAnimating} />
            </Absolute>
        </Button>
    );
};
